import React from "react";
import Link from "next/link";

export default function NewsletterCard({ lang = 'vn' }: { lang?: 'vn' | 'en' }) {
  return (
    <>
<section className="section-newsletter" style={{ background: "linear-gradient(180deg, #09071c 0%, #030014 100%)", padding: '60px 0' }}>
 <div className="card-newsletter">
  <div className="left-card-newsletter">
   <img alt="" className="image-newsletter" loading="lazy" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6a01d45ea0430b0093f585ab_TheEdge-White.svg"/>
   <div className="text-wrapper-card-newsletter">
    <div className="text-text-wrapper-card-newsletter">
     {lang === 'vn' ? 'Giới thiệu The Edge.' : 'Introducing The Edge.'}
    </div>
    <div className="subtext-wrapper-card-newsletter">
     {lang === 'vn' ? 'Bản tin mới của KeenEye về AI và công nghệ.' : 'KeenEye’s new newsletter on AI and technology.'}
    </div>
   </div>
  </div>
  <div className="right-card-newsletter">
   <a className="link-newsletter w-inline-block" href="/newsletter">
    <div className="text-link-newsletter">
     {lang === 'vn' ? 'Tham gia ngay' : 'Join the Edge'}
    </div>
   </a>
  </div>
  <img alt="" className="bg-image-card-newsletter" loading="lazy" sizes="100vw" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6a01d44cb5ea972e17aa694f_Frame%202147258091.avif" srcSet="
              https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6a01d44cb5ea972e17aa694f_Frame%202147258091-p-800.avif  500w,
              https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6a01d44cb5ea972e17aa694f_Frame%202147258091-p-800.avif  800w,
              https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6a01d44cb5ea972e17aa694f_Frame%202147258091.avif       1672w
            "/>
 </div>
</section>

    </>
  );
}
